import { render, staticRenderFns } from "./RegisterStocktaking.vue?vue&type=template&id=0f377dac&scoped=true&"
import script from "./RegisterStocktaking.vue?vue&type=script&lang=ts&"
export * from "./RegisterStocktaking.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterStocktaking.vue?vue&type=style&index=0&id=0f377dac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f377dac",
  null
  
)

export default component.exports